import axios from "axios";
var Axios = axios.create({
    baseURL: '//a.ajmide.com',
    timeout: 3000,
    withCredentials: true
  });

export const getVerifyCode = (phone) => new Promise((resolve, rej) => {
    Axios.get('/business/get_phone_code.php', { params: {
        joiner_verify_phone: phone
    }
    }).then(res => {
        console.log('getVerifyCode', res);
        if (res.data) {
            resolve(res.data)
        } else {
            rej(res)
        }
    })
    .catch(e => {
        rej(e)
    })
})

export const signIn = (reqbody) => new Promise((resolve, rej) => {
    console.log('getVerifyCode', reqbody);

    Axios.post('/business/apply.php', reqbody).then(res => {
        console.log('getVerifyCode', res);
        if (res.data) {
            resolve(res.data)
        } else {
            rej(res)
        }
    })
    .catch(e => {
        rej(e)
    })
})

export const uploadFile = (blobData) => new Promise((resolve, rej) => {
    let param = new FormData(); //创建form对象
    param.append('file',blobData);//通过append向form对象添加数据

    let config = {
        headers:{'Content-Type':'multipart/form-data'}
      }; //添加请求头
    axios.post('//a.ajmide.com/business/file_upload.php', param, config).then(res => {
        if (res.data) {
            resolve(res.data)
        } else {
            rej(res)
        }
    })
    .catch(e => {
        rej(e)
    })
})

export const getRunningOnlineContract = () => new Promise((resolve, rej) => {
    console.log('getRunningOnlineContract');

    Axios.post('/getRunningOnlineContract.php').then(res => {
        console.log('getRunningOnlineContract', res);
        if (res.data) {
            resolve(res.data)
        } else {
            rej(res)
        }
    })
    .catch(e => {
        rej(e)
    })
})
